import { getColorScheme } from '../../colors';
var toolbarDividerStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    var colors = getColorScheme(v.colorScheme);
    return {
      borderLeft: "1px solid ".concat(v.dividerBorder || colors.border),
      margin: v.dividerMargin,
      alignSelf: 'stretch'
    };
  }
};
export default toolbarDividerStyles;